<template>
  <a-modal
    title="信用分详情"
    style="top: 20px;"
    :width="1200"
    v-model="show"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :footer="false"
    :maskClosable="false"
  >
    <div class="center bold blue" style="fontSize:22px;">
      <div class="mr-100">姓名：{{ info.userName }}</div>
      <div class="ml-100">信用分：{{ info.creditScore }}</div>
    </div>
    <!-- 表格 -->
    <a-spin :spinning="spinning" delay="500">
      <div class="bold mt-30">信用加分</div>
      <a-table
        @change="handleTableChange"
        :pagination="false"
        :columns="columns"
        :data-source="data"
        bordered
        style="margin-top: 30px"
      >
        <span slot="action" slot-scope="text" v-if="text.orderId">
          <a @click="toDetail(text.orderId)">详情</a>
        </span>
      </a-table>
    </a-spin>
    <!-- 分页 -->
    <a-row type="flex" justify="end" style="margin-top: 50px">
      <a-pagination
        v-if="data.length != 0"
        show-quick-jumper
        v-model="page"
        :total="pageTotal"
        @change="onChangePage"
        :show-total="a => `总共 ${a} 条`"
      />
    </a-row>
    <!-- 表格 -->
    <a-spin :spinning="spinning1" delay="500">
      <div class="bold mt-30">信用减分</div>
      <a-table
        @change="handleTableChange1"
        :pagination="false"
        :columns="columns"
        :data-source="data1"
        bordered
        style="margin-top: 30px"
      >
        <span slot="action" slot-scope="text">
          <a @click="toDetail(text.orderId)">详情</a>
        </span>
      </a-table>
    </a-spin>
    <!-- 分页 -->
    <a-row type="flex" justify="end" style="margin-top: 50px">
      <a-pagination
        v-if="data1.length != 0"
        show-quick-jumper
        v-model="page1"
        :total="pageTotal1"
        @change="onChangePage1"
        :show-total="a => `总共 ${a} 条`"
      />
    </a-row>
    <edit-order-model ref="editorder" @Ok="query()"></edit-order-model>
  </a-modal>
</template>
<script>
import { addScoreList, reduceScoreList } from '@/api/master/MasterScore'
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    align: 'center'
  },
  {
    title: '订单编号',
    dataIndex: 'orderNo',
    align: 'center'
  },
  {
    title: '信用分',
    dataIndex: 'creditPoint',
    align: 'center',
    sorter: true
  },
  {
    title: '说明',
    dataIndex: 'content',
    align: 'center'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    align: 'center'
  },
  {
    title: '操作',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  data() {
    return {
      show: false,
      info: {}, // 师傅信息
      data: [],
      data1: [],
      columns,
      page: 1,
      page1: 1,
      pageTotal: '',
      pageTotal1: '',
      spinning: false,
      spinning1: false,
      sortField: '', // 排序字段
      sortOrder: '', // 升序降序
      sortOrder1: '' // 升序降序
    }
  },
  components: {
    editOrderModel: () => import('@/views/order/modules/editOrderModel')
  },
  methods: {
    init(info) {
      this.show = true
      this.info = info
      this.addList()
      this.reduceList()
    },
    // 排序
    handleTableChange(pagination, filters, sorter) {
      console.log(sorter)
      this.sortField = sorter.field
      this.sortOrder = sorter.order.slice(0, -3)
      this.addList()
    },
    handleTableChange1(pagination, filters, sorter) {
      console.log(sorter)
      this.sortField = sorter.field
      this.sortOrder1 = sorter.order.slice(0, -3)
      this.reduceList()
    },
    addList() {
      this.spinning = true
      addScoreList({
        userId: this.info.userId,
        pageNum: this.page,
        pageSize: 10,
        sortField: this.sortField,
        sortOrder: this.sortOrder
      }).then(data => {
        this.spinning = false
        if (data.code === 0) {
          this.pageTotal = data.total
          data.rows.forEach((item, i) => {
            this.$set(item, 'index', (this.page * 1 - 1) * 10 + i + 1)
          })
          this.data = data.rows
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    reduceList() {
      this.spinning1 = true
      reduceScoreList({
        userId: this.info.userId,
        pageNum: this.page1,
        pageSize: 10,
        sortField: this.sortField,
        sortOrder: this.sortOrder1
      }).then(data => {
        this.spinning1 = false
        if (data.code === 0) {
          this.pageTotal1 = data.total
          data.rows.forEach((item, i) => {
            this.$set(item, 'index', (this.page * 1 - 1) * 10 + i + 1)
          })
          this.data1 = data.rows
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    onChangePage(pageNumber) {
      this.page = pageNumber
      this.addList()
    },
    onChangePage1(pageNumber) {
      this.page1 = pageNumber
      this.reduceList()
    },
    toDetail(id) {
      // this.$refs.editorder.showeditOrder(value.orderId, 1, 1, '', value.auditStatus, 0, 1)
      this.$refs.editorder.showeditOrder(id)
    }
  }
}
</script>
<style scoped lang="less">
.bg-white {
  background: white;
}
</style>
